/**
 * textMessageDraftActions.js
 * Talkroute
 *
 * Created by Vel Genov on 8/14/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Constants for the different redux action types
 */
export const FILES_UPDATED = "FILES_UPDATED";
export const FILES_REMOVED = "FILES_REMOVED";

/**
 * An action to update the draft message files
 *
 * @param {*} files the files to update
 */
export const updateFiles = (files) => ({
  type: FILES_UPDATED,
  payload: { files },
});

/**
 * An action to clear the draft message files
 *
 */
export const clearFiles = () => ({
  type: FILES_REMOVED,
});

const textMessageDraftActions = {
  updateFiles,
  clearFiles,
};

export default textMessageDraftActions;
